<template>
  <!-- <v-app> -->
  <v-container fluid class="screen-wrapper">
    <v-layout row>
    <h3 class="heading display-1">Informačný systém pre cintoríny</h3>
    </v-layout>
    <v-layout row>
      <v-flex xs3 class="form elevation-3">
        <v-form v-model="valid" ref="form" lazy-validation>
          <v-text-field
            label="Meno"
            v-model="username"
            required
          ></v-text-field>
          <v-text-field
            label="Heslo"
            type="password"
            v-model="password"
            required
          ></v-text-field>
          <p class="invalid" v-if="isInvalid">Zadané meno alebo heslo je nesprávne!</p>
          <v-btn
            @click="submit"
            :disabled="!valid"
            color="primary"
          >
            Prihlásiť
          </v-btn>
        </v-form>
      </v-flex>
    </v-layout>
  </v-container>


  <!-- </v-app> -->
</template>

<script>
import { HTTP } from '../common/http'
import router from '../router'

export default {
  name: 'Login',
  data() {
    return {
      valid: true,
      password: '',
      username: '',
      isInvalid: false
    }
  },
  beforeCreate() {
    if (this.$store.getters.IS_LOGGED) {
      router.push('/')
    }
  },
  methods: {
    async submit() {
      this.isInvalid = false
      if (this.$refs.form.validate()) {
        await HTTP.post('/login', {
          username: this.username,
          password: this.password
        })
          .then(response => {
            if (response.status === 200) {
              localStorage.setItem('token', response.data.token)
              localStorage.setItem('role', 'admin')
              localStorage.setItem('id', response.data.id)
              localStorage.setItem('name', response.data.name)
              localStorage.setItem('logo', response.data.logo)
              localStorage.setItem('wmsUrl', response.data.wmsUrl)
              localStorage.setItem('wmsLayer', response.data.wmsLayer),
              localStorage.setItem('center', response.data.center),
              this.$store.commit('setUserInfo', response.data)
              router.push('/')
            }
          })
          .catch(err => {
            console.error(err)
            this.isInvalid = true
          })
      }
    }
  }
}
</script>
<style scoped>
.heading {
  margin: 0 auto;
  position: relative;
  font-size: 27px;
  text-transform: uppercase;
  color: #FFFFFF;
  font-weight: 600;
  margin-bottom: 30px;
}
.flex {
  margin: 0 auto;
}
.layout {
  top: 30%;
  position: relative;
}
.screen-wrapper {
  height: 100%;
  background-image: url('../assets/background.jpg');
  background-size: cover;
}
.form {
  background: hsla(0,0%,100%,.9);
  padding: 30px 30px 30px;
}
.invalid {
  color: red;
}
.btn {
  margin-left: 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/Login.vue